import { formatTime } from "../../utils/date-util";
import { formatDate } from "../../utils/Helper";
import "./AuctionEndDialog.scss";
import React from "react";

interface NewAddressFormProps {
  onSubmit: () => void;
  startTime: string;
  endTime: string;
  title: string;
  id: string;
  heading: string;
}

const AuctionEndDialog: React.FC<NewAddressFormProps> = ({
  onSubmit,
  startTime,
  endTime,
  title,
  id,
  heading,
}) => {
  return (
    <div className="auction-ended-confirmation-modal-alert-modal-box">
      <div className="flex-column align-items-center justify-content-center gap-12 px-16 py-12">
        <div className="flex-column gap-16">
          <div className=" flex-column gap-18 align-items-center justify-content-center">
            <div className="circular-alert-container flex-row align-items-center justify-content-center">
              <img
                width={43}
                height={40}
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250204104107-Group+1171276135.svg"
                alt="alert-icon"
              />
            </div>
            <p
              style={{ color: "#454545" }}
              className="xetgo-font-subHeading bold"
            >
              Auction {heading}
            </p>
            <p
              style={{ color: "#454545", width: "450px", textAlign: "center" }}
              className="xetgo-font-tag"
            >
              {heading === "Ended" &&
                "The auction has ended, No further bids can be placed."}
            </p>
          </div>
          <div className="flex-column gap-12 align-items-center justify-content-center xetgo-font-tag">
            <div className="flex-row align-items-center gap-13">
              <p className="bold">{title}</p>
              <p className="auction-id px-7 py-2">#{id}</p>
            </div>
            <p
              style={{ color: "#ABABAB", textAlign: "center" }}
              className="xetgo-font-tag "
            >
              {`${formatDate(startTime)} ${formatTime(
                startTime
              )} - ${formatDate(endTime)} ${formatTime(endTime)} `}
            </p>
          </div>
        </div>
      </div>
      <div className="auction-alert-btn-container flex-row gap-12 justify-content-center px-16 py-12">
        <div
          className="auction-confirm-btn auction-alert-btn flex-row align-items-center justify-content-center xetgo-font-tag py-6 px-10 cursor-pointer border-box"
          onClick={onSubmit}
        >
          Confirm
        </div>
      </div>
    </div>
  );
};

export default AuctionEndDialog;
